import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

// A QR code drawn as plain SVG rectangles from the module grid — no image
// URL, no innerHTML, nothing fetched (the CSP allows no third parties and the
// check-in path loads nothing external). Dark modules use the ink token so
// it prints and projects with full contrast; the quiet zone is white.
export function QrCode({ value, label, size = 240 }: { value: string; label: string; size?: number }) {
  const cells = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();
    const n = qr.getModuleCount();
    const dark: string[] = [];
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) if (qr.isDark(r, c)) dark.push(`M${c + 4} ${r + 4}h1v1h-1z`);
    }
    return { n: n + 8, path: dark.join('') };
  }, [value]);

  return (
    <svg
      className="qr"
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${cells.n} ${cells.n}`}
      shapeRendering="crispEdges"
    >
      <rect width={cells.n} height={cells.n} className="qr-bg" />
      <path d={cells.path} className="qr-fg" />
    </svg>
  );
}
